import * as types from './types';

export const showOverlay = payload => ({ type: types.SHOW, payload });

export const hideOverlay = () => ({ type: types.HIDE });
